<div class="row">
    <div class="col-md-12 pl-4">
        <yt-fw-default-update-buttons #defaultUpdateButtons></yt-fw-default-update-buttons>
    </div>
</div>
<yt-kurs-dokument-update #baseUpdate></yt-kurs-dokument-update>